import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, description, action, align = "left" }: SectionHeadingProps) {
  return (
    <div className={`mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${align === "center" ? "md:flex-col md:items-center md:text-center" : ""}`}>
      <div className={align === "center" ? "text-center" : ""}>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-600">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className={`mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${align === "center" ? "mx-auto" : ""}`}>
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}